<ion-header class="ion-no-border ion-header-modal-desktop">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        *ngIf="(platformService?.isTouchExperience$ | async) === false"
        id="close-modal-btn"
        data-cy="add-to-order-close-modal-button"
        (click)="closeModal()"
      >
        <ion-icon
          slot="icon-only"
          name="close-outline"
          data-cy="add-to-order-close-icon"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label data-cy="add-to-order-text">
      {{ 'i18n.orderPage.addToOrderModal.addProductToOrder' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-content-modal-desktop">
  <ion-grid>
    <ion-row>
      <!-- ADD TO ORDER OPTIONS -->
      <ion-col class="add-to-order-options">
        <ion-list>
          <ion-item-divider></ion-item-divider>
          <ion-item
            detail
            [ngClass]="{ selected: currentTab === 1 }"
            (click)="toggleTab(1)"
          >
            <ion-label class="add-to-order-option" data-cy="add-to-order-label">
              {{ 'i18n.orderPage.addToOrderModal.createNewOrder' | translate }}
            </ion-label>
          </ion-item>
          <ion-item
            detail
            [ngClass]="{ selected: currentTab === 2 }"
            (click)="toggleTab(2)"
          >
            <ion-label class="add-to-order-option" data-cy="add-to-order-label">
              {{
                'i18n.orderPage.addToOrderModal.addToExistingOrder' | translate
              }}
              ({{ vm?.length }}) <br />
              <span class="item-note" [ngClass]="{ selected: currentTab === 2 }"
                ><ng-container
                  *ngIf="vm?.length > 0; else noOrdersInAddProductsText"
                >
                  {{
                    'i18n.orderPage.addToOrderModal.timeToAddProducts'
                      | translate
                  }}
                </ng-container>
                <ng-template #noOrdersInAddProductsText>
                  {{
                    'i18n.orderPage.addToOrderModal.noOrdersInAddProducts'
                      | translate
                  }}
                </ng-template></span
              >
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-col>

      <!-- START ORDER INPUTS -->
      <ion-col [formGroup]="addToOrderModalForm" class="start-order-input">
        <ng-container *ngIf="currentTab === 1">
          <div class="start-label-container">
            <span class="start-order-label" data-cy="start-order-label">
              {{ 'i18n.orderPage.addToOrderModal.startOrder' | translate }}
            </span>
          </div>

          <div class="start-order-common-container">
            <ion-item *ngIf="!disablePO" class="start-order-name">
              <ion-label
                id="po-number"
                position="stacked"
                data-cy="start-order-label"
              >
                {{ 'i18n.orderPage.addToOrderModal.poNumber' | translate }}
                <span *ngIf="isCustomerRequirePO" class="required-span">*</span>
              </ion-label>
              <ion-input
                aria-labelledby="po-number"
                formControlName="poNumber"
                placeholder="Enter here"
                id="po-input"
                [appRegexInputValidator]="poRegex"
                data-cy="po-input"
                maxlength="20"
              ></ion-input>
            </ion-item>
            <span
              *ngIf="isCustomerRequirePO"
              class="required-field-error-message"
              >{{
                'i18n.orderPage.addToOrderModal.requiredFieldMessage'
                  | translate
              }}</span
            >
            <ng-container *ngIf="!isPoDisabledForVPTAndPunchOut">
              <ion-item
                *appShowSplit="[defaultPoFeatureFlag]"
                class="toggle-container"
              >
                <ion-label class="toggle-label">{{
                  'i18n.orderPage.saveDefaultPo' | translate
                }}</ion-label>
                <ion-toggle
                  formControlName="saveDefaultPo"
                  class="toggle-control"
                  data-cy="save-default-po-desktop-modal"
                ></ion-toggle>
              </ion-item>
            </ng-container>
            <div id="deliver-date">
              <ion-label
                position="stacked"
                data-cy="start-order-label"
                class="start-order-name"
              >
                {{ 'i18n.orderPage.addToOrderModal.deliveryDate' | translate }}
              </ion-label>
              <div class="selected-date-label">
                <span
                  >{{
                    'i18n.orderPage.addToOrderModal.dateSelected' | translate
                  }}:
                </span>
                {{
                  addToOrderModalForm.controls.selectedDeliveryDate.value
                    | date: 'M/d/yyyy' : 'GMT'
                    | lowercase
                }}
              </div>
            </div>
            <div class="calendar-container">
              <ion-datetime
                formControlName="selectedDeliveryDate"
                presentation="date"
                mode="ios"
                size="cover"
                data-cy="delivery-date-calendar"
                [min]="minDeliveryDate"
                [isDateEnabled]="isEligibleDay"
                [highlightedDates]="prontoDayStyle"
              >
              </ion-datetime>
              <div
                *ngIf="prontoDeliveryDays !== undefined"
                class="calendar-date-options"
              >
                <ion-item lines="none">
                  <ion-icon
                    name="ellipse"
                    size="large"
                    [style.color]="'#F3BA1633'"
                  ></ion-icon>
                  <p>
                    {{ 'i18n.common.prontoDelivery' | translate }}
                  </p>
                </ion-item>
                <ion-item lines="none">
                  <ion-icon
                    name="ellipse"
                    size="large"
                    [style.color]="'#DDE6D2'"
                  ></ion-icon>
                  <p>
                    {{ 'i18n.common.standardDelivery' | translate }}
                  </p>
                </ion-item>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="currentTab === 2">
          <div class="select-label-container">
            <span class="start-order-label" data-cy="start-order-label">
              {{
                'i18n.orderPage.addToOrderModal.selectExistingOrder' | translate
              }}
            </span>
            <ion-radio-group>
              <ng-container
                *ngFor="let rowItem of vm; trackBy: trackItem; let i = index"
              >
                <app-add-to-order-products
                  (selectionEmitter)="onOrderSelected(rowItem)"
                  [vm]="rowItem"
                  [index]="i"
                ></app-add-to-order-products>
              </ng-container>
            </ion-radio-group>
          </div>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        class="usf-outline-green-dsktp-tblt-modal-button"
        data-cy="add-to-order-cancel-button"
        (click)="closeModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        data-cy="add-to-order-next-button"
        [ngClass]="
          currentTab === 1 || !!selectedOrderDetails
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-disabled-dsktp-tblt-modal-button'
        "
        [disabled]="currentTab === 2 && !selectedOrderDetails"
        (click)="onSubmit(currentTab, addToOrderModalForm)"
      >
        {{ 'i18n.orderPage.addToOrderModal.addProduct' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
